import { ManagementTenant, TenantConfiguration } from '@xeetr/types/models'

export const transformToManagementTenant = (config: TenantConfiguration): ManagementTenant => {
  const { settings, info, ...rest } = config

  return {
    ...rest,
    timezone: info.timezone,
    defaultBookingState: settings.defaultStateBookings,
    requireMail: settings.requireEmail,
    requirePhone: settings.requirePhone,
    requireAddress: settings.requireAddress,
    useLengthOfStay: settings.useLengthOfStay,
    defaultLengthOfStay: settings.defaultLengthOfStay,
    showTimeInDashboard: settings.showTimeInDashboard ?? false,
    showCopyLinkInDashboard: settings.showCopyLinkInDashboard,
    showStatisticsInDashboard: settings.showStatisticsInDashboard,
    markMultipleUsedTables: settings.markMultipleUsedTables,
    highlightOutdated: settings.highlightOutdated,
    thresholdOutdated: settings.thresholdOutdated,
    anyroom: settings.anyroom,
    calendarType: settings.calendarType,
    calendarDisplayPreference: settings.calendarDisplayPreference,
    calendarRoomOrder: settings.calendarRoomOrder,
    calendarTimeRange: settings.calendarTimeRange,
    refreshDuration: settings.refreshDuration,
    notifyNewBookingDashboard: settings.notifyOnNewBookingDashboard,
    showAddressInCalendar: settings.showAddressInCalendar,
    visibleDashboardColumns: settings.visibleDashboardColumns,
    visibleCustomerColumns: settings.visibleCustomerColumns,
    includeCancelLinkInCalendarAttachment: settings.includeCancelLinkInCalendarAttachment,
    bookingCustomFields: settings.bookingCustomFields,
    defaultRoom: rest.rooms.find((room) => !room.id),
    events: [],
  }
}
